<template>
  <div>
    <section class="content">
      <div class="col-md-12" v-if="getMember.arbitrage">
        <div class="portlet light">
          <div class="portlet-title" :style="{ 'min-height': '32px' }">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Mes prestations d'arbitre</span>
                <span class="caption-helper"></span>
              </div>

            </div>
          </div>
          <div class="portlet-body">
            <table class="table table-responsive table-hover"
                   v-if="getMember.arbitrage.length>0">
              <thead>
              <tr>
<!--                <th>Date</th>-->
                <th width="200">Compétition</th>
                <th>Date de début</th>
                <th>Date de fin</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="compet in getOrderByDate(getMember.arbitrage)">
                <td>{{compet.competition_name}}</td>
<!--                <td>{{compet.date_debut}}</td>-->
                <td>{{ formatDate(compet.date_debut,'YYYY-MM-DD','DD/MM/YYYY') }}</td>
                <td>{{ formatDate(compet.date_fin,'YYYY-MM-DD','DD/MM/YYYY') }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="getMember.arbitrage.length==0">Aucune prestation trouvée</div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import moment from 'moment/moment'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        methods: {
            currentYear: function () {
                return moment().year();
            },
            getPlaceExposant(place) {
                switch (place) {
                    case 1:
                        return 'er'
                    default:
                        return 'ème'
                }
            },
            getName(key) {
                switch (key) {
                    case "aisf":
                        return "AISF";
                        break;
                    case "abft":
                        return "ABFT";
                        break;
                    case "abitre_cbt":
                        return "Arbitrage combat";
                        break;
                    case "adeps":
                        return "ADEPS";
                        break;
                    case "arbitre_tch":
                        return "Arbitrage technique";
                        break;
                    case "ETU":
                        return "ETU";
                        break;
                    case "WTF":
                        return "WT";
                        break;
                }
                return "";
            },
            // getCompetitionsOrdered: function () {
            //     let ordered = [];
            //     let these = this
            //     this.getMember.arbitrage.forEach(function (item, index, array) {
            //         if (these.getMember.arbitrage[item])
            //             ordered.push({item: these.getMember.formations[item]});
            //     })
            //     return ordered;
            // },
            formatDate: function (value, ftmIn, fmtOut) {
                if (value == null) return ''
                fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
                return moment(value, ftmIn).format(fmtOut)
            },
            getArbitrage() {
                return this.getMember.arbitrage && this.getMember.arbitrage.length > 0 ? this.getMember.arbitrage : []
            },
            // getFormations() {
            //     return [
            //         this.getMember().formations.aisf,
            //         this.getMember().formations.adeps,
            //         this.getMember().formations.abitre_cbt,
            //         this.getMember().formations.arbitre_tch,
            //         this.getMember().formations.abft
            //     ]
            // },
            getOrderByDate(formations) {
                return _.sortBy(formations, 'dateSorted',).reverse()
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Member/Arbitrage.vue